import { createSlice } from '@reduxjs/toolkit';
import {
  PoiModalDraftFormType,
  PoiModalNearbyPoiType,
  PoiModalState,
  PoiModalSelectedFlightlogEventType
} from '../../../types/poiModal';
import { LocationType } from '../../../common/api/spidertracks-sdk/types/PointOfInterest';

const initialState: PoiModalState = {
  selectedFlightlogEvent: undefined,
  nearbyPois: undefined,
  loadingNearbyPois: false,
  allLocationTypes: [],
  draftForm: undefined
};

export const poiModalSlice = createSlice({
  name: 'poiModal',
  initialState,
  reducers: {
    setSelectedFlightlogEvent: (
      state,
      action: { payload: PoiModalSelectedFlightlogEventType; type: string }
    ) => {
      state.selectedFlightlogEvent = action.payload;
    },
    setNearbyPois: (
      state,
      action: { payload: PoiModalNearbyPoiType[] | undefined; type: string }
    ) => {
      state.nearbyPois = action.payload;
    },
    setLoadingNearbyPois: (state, action: { payload: boolean; type: string }) => {
      state.loadingNearbyPois = action.payload;
    },
    setAllLocationTypes: (state, action: { payload: LocationType[]; type: string }) => {
      state.allLocationTypes = action.payload;
    },
    setDraftForm: (state, action: { payload: PoiModalDraftFormType; type: string }) => {
      state.draftForm = action.payload;
    },
    resetPoiModal: state => {
      state.draftForm = undefined;
      state.nearbyPois = undefined;
      state.selectedFlightlogEvent = undefined;
      state.loadingNearbyPois = false;
    }
  }
});

export const {
  setSelectedFlightlogEvent,
  setNearbyPois,
  setLoadingNearbyPois,
  setDraftForm,
  setAllLocationTypes,
  resetPoiModal
} = poiModalSlice.actions;

export default poiModalSlice.reducer;
